'use strict';//Indicating browser should run only in java script mode

var ReasonforAdmissionModule = angular.module('EMR.ReasonforAdmissionModule', [])